/** 通知卡片视觉语气：仅业务待办用警告黄，其余为常规。 */
export function resolveTiktokAlertTone(item) {
  if (item?.source === 'business') return 'warning';
  return 'info';
}
